import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import axios from "axios";
import { useAuth } from "@/auth/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SubscriptionContext = createContext(null);
export const useSubscription = () => useContext(SubscriptionContext);

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [sub, setSub] = useState(null);
  const [bags, setBags] = useState([]);
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [upgradeReason, setUpgradeReason] = useState("");

  const refresh = useCallback(async () => {
    if (!(user && user.id)) {
      setSub(null);
      return;
    }
    try {
      const { data } = await axios.get(`${API}/subscription/status`);
      setSub(data);
    } catch (_) {
      /* ignore */
    }
  }, [user]);

  useEffect(() => {
    refresh();
    axios.get(`${API}/payments/bags`).then((r) => setBags(r.data)).catch(() => {});
  }, [refresh]);

  const openUpgrade = useCallback((reason = "") => {
    setUpgradeReason(reason);
    setShowUpgrade(true);
  }, []);

  const buyBag = useCallback(async (lookup_key) => {
    const { data } = await axios.post(`${API}/payments/checkout-bag`, {
      lookup_key,
      origin_url: window.location.origin,
    });
    window.location.href = data.checkout_url;
  }, []);

  const isPro = !!sub?.is_pro;
  const gen = sub?.generations || null;

  return (
    <SubscriptionContext.Provider
      value={{ sub, gen, isPro, bags, buyBag, refresh, showUpgrade, setShowUpgrade, openUpgrade, upgradeReason }}
    >
      {children}
    </SubscriptionContext.Provider>
  );
}
